import { Typography } from '@mui/material'
import * as React from 'react'

interface SectionTitleProps {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  children: React.ReactNode
  customStyles?: React.CSSProperties
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  variant = 'h2',
  customStyles = {},
  children,
}) => {
  return (
    <Typography
      variant={variant}
      sx={{
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '20px',
        lineHeight: '32px',
        letterSpacing: '0.15px',
        padding: '16px',
        boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.12)',
        ...customStyles,
      }}
    >
      {children}
    </Typography>
  )
}
